module.exports = __webpack_public_path__ + "static/media/thanks.6b10e2e7.jpg";